export enum Area {
    Admin = '/admin',
    Default = '/'
}
